import React from 'react';
import { notImg } from '../../assets/images/product/prodImages';
import { SERVER_URL } from '../../config';
import sty from './ProdDetailPage.module.css';

const PrdDtlImg = ({ imgSeq, imgPath, imgSort, handleImageClick }) => {
    const handleClick = imgPath && imgPath !== notImg ? () => handleImageClick(imgSeq, imgPath, imgSort) : null;
  
    const mainImageClass = imgSort === 0 ? sty.mainImg : sty.subImg;
  
    return (
      <img
        onClick={handleClick}
        key={imgSeq || `notImg_${imgSort}`}
        className={imgSeq ? mainImageClass : sty.notImg}
        src={imgSeq ? SERVER_URL + imgPath : notImg}
        alt={imgSeq ? imgSort : "Not Img"}
      />
    );
};

export default PrdDtlImg;